import {RsnButton, RsnDialog} from '@raison/ui-kit';
import {format} from 'date-fns/format';
import React from 'react';

export function TooManyFailedAttemptsDialog({retryAfterTs, onClose}: {retryAfterTs: number; onClose?: () => void}) {
    const timeString = format(new Date(retryAfterTs), 'HH:mm');
    return (
        <RsnDialog.Window onClose={onClose}>
            <RsnDialog.CenteredHeader icon={{element: <RsnDialog.StatusIcon status={'alert'} />}}>
                Too many failed attempts
            </RsnDialog.CenteredHeader>
            <RsnDialog.Body>For security reasons, you can try again after {timeString}.</RsnDialog.Body>
            <RsnDialog.Footer>
                <RsnButton.Alike as={RsnDialog.CloseTrigger} intent={'secondary'}>
                    I got it
                </RsnButton.Alike>
            </RsnDialog.Footer>
        </RsnDialog.Window>
    );
}
